/**
 * @file
 * Blog Category modal JS.
*/
(function ($, Drupal, drupalSettings) {

  'use strict';

  /**
   * Convert block list (links) to carousel at mobile.
   */
  Drupal.behaviors.blogCategoryModal = {
    attach: function(context, settings) {
      // We need to detach the modal and place it on the body so it doesn't break.
      $(once('kinaxisBlogCategoryModal', '#blogCategoryModal')).each(function () {
        $(this).detach().appendTo('body');
      });
    }
  }

})(jQuery, Drupal, drupalSettings);